export default __webpack_public_path__ + "static/media/featureBg.5f07c337.png";